export const wyzywienie = {
  wyz: [
    "Unknown",
    "AI - All Inclusive",
    "HB - Dwa posiłki",
    "BB - Śniadanie",
    "RO - Bez wyżywienia",
    "Według programu",
    "FB - Pełne wyżywienie",
    "Snack",
    "Według programu"
  ],
  wyzwysz: [
    "",
    "AI - All Inclusive",
    "HB - Dwa posiłki",
    "BB - Śniadanie",
    "RO - Bez wyżywienia",
    "Według programu",
    "FB - Pełne wyżywienie",
    "Snack",
    "Według programu"
  ],
  wyzvals: ["", "AI", "HB", "BB", "brak", "prog", "FB", "snack", "prog"]
};
